module.exports = __webpack_public_path__ + "static/img/cover5.50d316f7.jpg";